/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserMlpResponseDto } from '../../models/user-mlp-response-dto';

export interface AdminUserMlpControllerGetUserMlpById$Params {
  id: string;
}

export function adminUserMlpControllerGetUserMlpById(http: HttpClient, rootUrl: string, params: AdminUserMlpControllerGetUserMlpById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserMlpResponseDto>> {
  const rb = new RequestBuilder(rootUrl, adminUserMlpControllerGetUserMlpById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserMlpResponseDto>;
    })
  );
}

adminUserMlpControllerGetUserMlpById.PATH = '/admin/user-mlp/{id}';
